const translations = {
}

export default translations


